import { useState, useEffect } from 'react'

const DEFAULT_BREAKPOINT = 768

const useIsMobile = (breakpoint = DEFAULT_BREAKPOINT) => {
  const getIsMobile = () => {
    if (typeof window === 'undefined') return true
    return window.innerWidth < breakpoint
  }

  const [isMobile, setIsMobile] = useState(getIsMobile)

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${breakpoint - 1}px)`)

    const updateIsMobile = () => {
      setIsMobile(window.innerWidth < breakpoint)
    }

    updateIsMobile()
    window.addEventListener('resize', updateIsMobile)
    window.addEventListener('orientationchange', updateIsMobile)

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', updateIsMobile)
    } else {
      mediaQuery.addListener(updateIsMobile)
    }

    return () => {
      window.removeEventListener('resize', updateIsMobile)
      window.removeEventListener('orientationchange', updateIsMobile)

      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', updateIsMobile)
      } else {
        mediaQuery.removeListener(updateIsMobile)
      }
    }
  }, [breakpoint])

  return isMobile
}

export default useIsMobile
